// AI-GEN-BEGIN - 清理废弃代码，generateRouter / filterAsyncRoutes / convertRouter 已迁移至 route.ts
const usePermissionStore = defineStore(
  'permission',
  () => {
    return {}
  },
)

export default usePermissionStore
// AI-GEN-END
